import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug

const getAllVendors = () => axios.get(`${getWorkspaceId()}/vendors/all`)

const getVendors = (params) => axios.get(`${getWorkspaceId()}/vendors/paginated`, { params })

const getDetailVendor = (slug) => axios.get(`${getWorkspaceId()}/vendors/${slug}`)
const createVendor = (formData) => axios.post(`${getWorkspaceId()}/vendors`, formData)
const updateVendor = ({ formData, slug }) => axios.patch(`${getWorkspaceId()}/vendors/${slug}`, formData)
const updateVendorsStatus = (formData) => axios.patch(`${getWorkspaceId()}/vendors/status`, formData)
const deleteVendor = (data) => axios.delete(`${getWorkspaceId()}/vendors`, { data })

const getVendorFiltersAndSorting = () => axios.get(`${getWorkspaceId()}/vendors/filters-and-sorting`)

const countersVendor = (formData) => axios.post(`${getWorkspaceId()}/vendors/counters`, formData)

const resetCapsVendor = (slug) => axios.delete(`${getWorkspaceId()}/vendors/${slug}/caps`)

export {
    getAllVendors,
    getVendors,
    getDetailVendor,
    createVendor,
    updateVendor,
    updateVendorsStatus,
    deleteVendor,
    getVendorFiltersAndSorting,
    countersVendor,
    resetCapsVendor,
}
